"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentIndicator = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/dot/dot");
require("@/components/overlay/tooltip");
/**
 * 지금 위치한 항목을 가리키는 점.
 * 현재라는 의미는 항목의 aria-current가 전하므로, 이 요소는 현재 항목에만 놓여 화면용 표시만 맡는다.
 * 점이 무엇인지는 포인터를 올렸을 때 툴팁으로 알리며, 점보다 넓은 영역을 잡아 가운데에 점을 둔다.
 * 자리는 항목이 정한다: 가로로 늘어선 항목은 아래 가운데(dotBelowStyles), 세로 목록은 행 끝에 둔다.
 */
let CurrentIndicator = class CurrentIndicator extends lit_1.LitElement {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('aria-hidden', 'true');
    }
    render() {
        return (0, lit_1.html) `
      <mm-tooltip content="현재 위치" placement="bottom">
        <span slot="trigger">
          <mm-dot tone="gray" size="6"></mm-dot>
        </span>
      </mm-tooltip>
    `;
    }
};
CurrentIndicator.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
      flex-shrink: 0;
    }

    /* 툴팁은 트리거 위에서 열리므로, 점이 아니라 24 영역 전체를 트리거로 잡고 점은 가운데 둔다. */
    [slot='trigger'] {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: var(--size-24);
      height: var(--size-24);
    }
  `;
CurrentIndicator = __decorate([
    (0, decorators_js_1.customElement)('mm-current-indicator')
], CurrentIndicator);
exports.CurrentIndicator = CurrentIndicator;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3VycmVudC1pbmRpY2F0b3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjdXJyZW50LWluZGljYXRvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQWlEO0FBRWpELHVDQUFvQztBQUNwQyx3Q0FBcUM7QUFFckM7Ozs7O0dBS0c7QUFFSSxJQUFNLGdCQUFnQixHQUF0QixNQUFNLGdCQUFpQixTQUFRLGdCQUFVO0lBaUI5QyxpQkFBaUI7UUFDZixLQUFLLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtRQUN6QixJQUFJLENBQUMsWUFBWSxDQUFDLGFBQWEsRUFBRSxNQUFNLENBQUMsQ0FBQTtJQUMxQyxDQUFDO0lBRUQsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7Ozs7OztLQU1WLENBQUE7SUFDSCxDQUFDOztBQTdCTSx1QkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7OztHQWNsQixDQUFBO0FBZlUsZ0JBQWdCO0lBRDVCLElBQUEsNkJBQWEsRUFBQyxzQkFBc0IsQ0FBQztHQUN6QixnQkFBZ0IsQ0ErQjVCO0FBL0JZLDRDQUFnQiJ9